<template>
  <div class='about container-flfluid'>

    <div class="imgDiv">
      <img class="img" :src="aboutList.img">
    </div>
    <div class="section about-s about-s1">
      <div class="w1200 flex-direction-column">
        <div class="titleLine flex flex-direction-column">
          <h2>{{ aboutList.companyProfileTitle }}</h2>
          <h3 class="centerbox">{{ aboutList.companyProfileTitleEn }}</h3>
        </div>
        <div class="flexbox s1-flex">
          <div class="itemP" v-html="content"></div>
        </div>
      </div>

    </div>
    <div class="lineDiv"></div>

    <div class="section about-s about-s2">
      <div class="w1200 flex-direction-column">
        <div class="titleLine flex flex-direction-column w1200">
          <h2>{{ aboutList.qualificationsTitle }}</h2>
          <h3 class="centerbox">{{ aboutList.qualificationsTitleEn }}</h3>
        </div>
      </div>

      <div class="about-s2-bg">
        <div class="w1200 tieBlock">
          <div class="tiePicDiv">
            <img src="../../assets/images/tie.png" class="tie">
          </div>
          <div class="img-ul betweenbox align-start tiePics">
            <img :src="aboutList.img1" class="img1">
            <img :src="aboutList.img2" class="img2">
            <img :src="aboutList.img3" class="img3">
            <img :src="aboutList.img4" class="img4">
            <img :src="aboutList.img5" class="img5">
            <img :src="aboutList.img6" class="img6">
          </div>
        </div>
      </div>

    </div>
    <div class="section about-s about-s3">
      <div class="w1200 flex-direction-column">
        <div class="titleLine flex flex-direction-column">
          <h2>{{ aboutList.trendsTitle }}</h2>
          <h3 class="centerbox">{{ aboutList.trendsTitleEn }}</h3>
        </div>
        <h4 class="flexbox">{{ aboutList.new }}</h4>
        <div class="flexbox align-start s3-flex">

          <div class="v-swiperbox">
            <!-- :interval="5000"  -->
            <el-carousel trigger="click" arrow="always">
              <el-carousel-item v-for="(item, index) in aboutList.carouselList" :key="index">

                <!-- href="03-news-video.html" -->
                <a class="flexbox columnbox v-box" @click="goAboutDetail(item.title)">
                  <div class="v-pic centerbox">
                    <img :src="item.img">
                  </div>
                  <span class="betweenbox align-start title">
                    <h5>{{ item.title }}</h5>
                    <font>{{ item.time }}</font>
                  </span>
                  <p class="desTip">{{ item.text }}</p>
                </a>

              </el-carousel-item>
            </el-carousel>

          </div>

          <div class="betweenbox columnbox n-box">
            <a class="flexbox n-item align-start" v-for="(item, index) in aboutList.newList" :key="index" @click="goAboutDetail(item.title)">
              <img :src="item.img">
              <div class="text centerbox columnbox">
                <span class="flexbox title">
                  <h5>{{ item.title }}</h5>
                </span>
                <p class="des">{{ item.text }}</p>
                <span class="flex betweenbox bottom">
                  了解详情&gt;&gt;
                  <font>{{ item.time }}</font>
                </span>
              </div>
            </a>
          </div>
        </div>
      </div>

    </div>
    <div class="btnLine flex flex-justify-content">
      <a class="centerbox more-a" @click="goAboutList()">查看更多</a>
    </div>
    <section class="section about-s about-s4">
      <div class="w1200 flex-direction-column">
        <div class="titleLine flex flex-direction-column">
          <h2>{{ aboutList.ContactUsTitle }}</h2>
          <h3 class="centerbox">{{ aboutList.ContactUsTitleEn }}</h3>
        </div>

        <div class="flex betweenbox s4-flex">
          <div class="s4-item centerbox columnbox" v-for="(item, index) in aboutList.ContactUsList" :key="index" >
            <span class="centerbox name">{{ item.name }}</span>
            <span class="centerbox addr"><img src="../../assets/images/ico-addr.png">{{ item.add }}</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
  
  <script>
import axios from 'axios'
export default {
  metaInfo() {
    return {
      title: "关于我们-健新",
      meta: [
        { name: "keywords", content: "keyword1, keyword2, keyword3" },
        { name: "description", content: "Page description" },
      ],
    };
  },
  mounted() {
    // const element = getScrollParent(this.$el)
    // element.scrollTop = 0
  },
  data() {
    return {
      content: "",//公司介绍
      aboutList: {
        img:"",
        companyProfileTitle: "",
        companyProfileTitleEn: "",
        companyProfileList: [],
        developmentTitle: "",
        developmentHistory: [],
        cultureTitle: "",
        cultureList:[],
        qualificationsTitle: "",
        qualificationsTitleEn:"",
        img1:"",
        img2:"",
        img3:"",
        img4:"",
        img5:"",
        img6:"",
        trendsTitle: "",
        trendsTitleEn: "",
        new: "",
        newList:[],
        carouselList:[],
        ContactUsTitle:"",
        ContactUsTitleEn:"",
        ContactUsList:[]
      },
    }
  },
  created() {
     this.getList()
     this.geContertList()
  },
  methods: {
    getList() {
      let data = {
        Title: "关于我们",
        ForumTypeCode: "jxAbout",
      };
      axios
        .post("api/Forum/GetDoc", { ...data })
        .then((res) => {
          if (res) {
           this.aboutList = JSON.parse(res.data.OutputData.Content)
          } else {
            this.$message({
              type: "error",
              message: "请求数据失败",
            });
          }
        });
    },
    geContertList() {
      let data = {
        Title: "关于我们-公司介绍",
        ForumTypeCode: "jxAbout",
      };
      axios
        .post("api/Forum/GetDoc", { ...data })
        .then((res) => {
          if (res) {
            this.content = res.data.OutputData.Content
          } else {
            this.$message({
              type: "error",
              message: "请求数据失败",
            });
          }
        });
    },
    goAboutList() {
      this.$router.push({ name: 'aboutList' })
    },
    goAboutDetail(name) {
      this.$router.push({
        name:"aboutDetail",
        query:{
            title:name
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/base.less";

.about {
  width: 100%;
  line-height: 1.7;
  .imgDiv {
    width: 100%;
    .img {
      width: 100%;
      height: auto;
      min-height: 100%;
    }
  }
  .about-s {
    text-align: center;
    h2 {
      color: #333;
      font-weight: bold;
    }
    h3 {
      color: #333;
      font-weight: bold;
    }
    h3:before {
      content: "";
      background: url(../../assets/images/at-left.png) center center no-repeat;
      background-size: cover;
    }
    h3:after {
      content: "";
      background: url(../../assets/images/at-right.png) center center no-repeat;
      background-size: cover;
    }
  }
  .about-s1 {
    border-bottom: 1PX solid #e4e4e4;
    .titleLine {
      width: 100%;
    }
    .lineDiv {
      width: 100%;
      height: 1PX;
      border-bottom: 1PX solid #e4e4e4;
    }
    .s1-flex {
      width: 100%;

      .itemP {
        width: 100%;
        .des {
          text-align: justify;
          vertical-align: baseline;
          span {
            color: rgb(102, 102, 102);
            letter-spacing: 0PX;
            background: rgb(255, 255, 255);
            font-family: arial, helvetica, sans-serif;
            font-size: 16PX;
          }
        }
        .brLine {
          white-space: normal;
          margin-top: 0PX;
          margin-bottom: 0PX;
          padding: 0PX;
          box-sizing: border-box;
        }
        .tipLine {
          box-sizing: border-box;
          text-align: center;
          .tip {
            background-color: rgb(68, 68, 68);
            color: rgb(255, 255, 255);
            box-sizing: border-box;
            font-weight: bold;
          }
        }
        .desItem {
          white-space: normal;
          margin-top: 0PX;
          margin-bottom: 0PX;
          padding: 0PX;
          color: #666;
          box-sizing: border-box;

          line-height: 2.5;
          .boldTip {
            font-weight: bold;
          }
        }
        .desItem_left{
          white-space: normal;
          margin-top: 0PX;
          margin-bottom: 0PX;
          padding: 0PX;
          color: #666;
          box-sizing: border-box;

          line-height: 2.5;
          .boldTip {
            font-weight: bold;
          }
        }
      }
    }
  }
  .about-s2 {
    text-align: center;
    .tiePic {
      width: 100%;
      height: auto;
    }
    img {
      max-width: 100%;
      border: none;
      font-size: 0;
      outline-width: 0PX;
      vertical-align: top;
    }
    .about-s2-bg {
      width: 100%;

      background: url(../../assets/images/s2-bg.jpg) center center no-repeat;
      background-size: cover;
      position: relative;

      .tieBlock {
        position: relative;
        flex-wrap: wrap;
        .tiePicDiv {
          display: flex;
          flex-direction: column;
          margin: 0 auto;
        }
        .tiePics {
          width: 78%;
          position: absolute;
        }
      }

      .tie1 {
        width: 100%;
        height: auto;
        border: none;
        font-size: 0;
        outline-width: 0PX;
        vertical-align: top;
        position: absolute;
        z-index: -2;
      }
      .tie2 {
        max-width: 100%;
        border: none;
        font-size: 0;
        outline-width: 0PX;
        vertical-align: top;
        position: absolute;
        z-index: -2;
      }
    }
    .about-s2 .w1200 {
      height: auto;
    }
  }
  .about-s3 {
    h4 {
      color: #333;
      font-weight: normal;
      line-height: 1;
    }
    h4:before {
      content: "";
      background: #333;
    }
    .s3-flex {
      .v-swiperbox {
        border: 1PX solid #e9e9e9;
        transition: all .5s;
        .swiper-container {
          width: 100%;
          height: 100%;
          overflow: hidden;
          margin-left: auto;
          margin-right: auto;
          position: relative;
          list-style: none;
          padding: 0;
          z-index: 1;
        }
        .swiper-wrapper {
          position: relative;
          width: 100%;
          height: 100%;
          z-index: 1;
          display: flex;
          transition-property: transform;
          box-sizing: content-box;
        }
        .swiper-slide {
          width: 486PX;
          height: 396PX;
          border: 1PX solid #e9e9e9;
          transition: all .5s;
        }
        a.v-box {
          width: 100%;
          height: 100%;
        }
        .v-pic {
          position: relative;
          width: 100%;
          overflow: hidden;
          img {
            // width: auto;
            // max-width: none;
          }
        }
        .v-pic:after {
          content: "";
          background: url(../../assets/images/play-ico.png) center center no-repeat;
          background-size: cover;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          -webkit-transform: translate(-50%, -50%);
        }
        span {
          color: #333;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          width: 100%;
          h5 {
            font-weight: normal;
            text-align: left;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 80%;
          }
          font {
            color: #969696;
            font-size: 12PX;
            line-height: 48PX;
          }
        }
        .desTip {
          width: 100%;
          color: #888;
          text-align: left;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .v-box:hover h5 {
          color: #197ECB;
        } // .v-box:hover .v-pic img {
        //   -webkit-animation: animations 5s linear infinite alternate;
        //   animation: animations 13s linear infinite alternate;
        // }
      }
      .n-box {
        .n-item:hover .title h5 {
          color: #197ECB;
        }
      }
      .n-box .n-item {
        width: 100%;
        transition: all .5s;
        img {
          flex: none;
          height: auto;
        }
        .text {
          height: 100%;
          border-bottom: 1PX dashed #e9e9e9;
        }
      }
      .n-box .n-item .text .bottom {
        color: #888;
      }
      span {
        color: #333;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
      }
      span h5 {
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .n-box span h5 {
        width: 100%;
        max-width: 100%;
      }
      span font {
        color: #969696;
      }
      p.des {
        width: 100%;
        color: #888;
        text-align: left;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      } // .v-box:hover .v-pic img {
      //   -webkit-animation: animations 5s linear infinite alternate;
      //   animation: animations 13s linear infinite alternate;
      // }
    }
  } // 查看更多
  .btnLine {
    width: 100%;
    .more-a {
      border: 1PX solid #d2d2d2;
      color: #969696;
    }
    a:hover {
      text-decoration: none;
      color: #333;
    }
  }
  .about-s4 {
    background: #f9f9f9;
    .s4-item {
      background: #fff;
      border: 1PX solid #ffd5be;
      .name {
        color: #333;
      }
      .addr {
        color: #969696;
        text-align: center;
      }
    }
  }

  .bgImg {
    width: 100%;
    height: auto;
    img {
      width: 100%;
      height: auto;
    }
  }
  @media only screen and (min-width: 1200px) {
    .imgDiv {
      padding-top: 150PX;
    }
    .about-s {
      padding-top: 50PX;
      padding-bottom: 70PX;
      h2 {
        font-size: 28PX;
      }
      h3 {
        font-size: 14PX;
        margin-bottom: 60PX;
      }
      h3:before {
        width: 115PX;
        height: 12PX;
        margin-right: 22PX;
      }
      h3:after {
        width: 115PX;
        height: 12PX;
        margin-left: 22PX;
      }
    }
    .about-s1 {
      .titleLine {
        h3 {
          margin-top: 5PX;
        }
      }
      .s1-flex {
        .itemP {
          .des {
            margin: 0PX;
            padding: 0PX;
            text-indent: 2em;
            span {
              font-size: 16PX;
            }
          }
          .tipLine {
            .tip {
              font-size: 20PX;
            }
          }
          .desItem {
            font-size: 18PX;
          }
          .desItem_left {
            font-size: 18PX;
            text-align: left;
          }
        }
      }
    }
    .about-s2 {
      padding-bottom: 70PX;
      margin-top: 50PX;
      .about-s2-bg {
        padding-top: 60PX;
        padding-bottom: 80PX;
        height: 495.45PX;
        .tieBlock {
          height: 356PX;
          flex-wrap: wrap;
          .tiePicDiv {
            width: 1149PX;
            height: 155PX;
            img {
              width: 1149PX;
              height: 155PX;
            }
          }
          .tiePics {
            top: 95PX;
          }
        }
      }
      .about-s2-bg .img-ul img {
        box-shadow: 0 9PX 10PX rgba(53, 53, 53, .4);
        width: 170PX;
      }
      .about-s2-bg .img2 {
        margin-left: 15PX;
      }
      .about-s2-bg .img3 {
        margin-left: 20PX;
      }
    }
    .about-s3 {
      h4 {
        font-size: 22PX;
        margin-bottom: 30PX;
      }
      h4:before {
        width: 2PX;
        height: 22PX;
        margin-right: 18PX;
      }
      .more-a {
        margin: 50PX auto 0 auto;
      }
      .s3-flex {
        .v-swiperbox {
          width: 486PX;
          height: 396PX;
          margin-right: 50PX;
          /deep/.el-carousel__arrow {
            width: 27PX !important;
            height: 44PX !important;
            .el-icon-arrow-left,
            .el-icon-arrow-right {
              font-size: 44PX;
            }
          }
        }
        .v-pic {
          margin-bottom: 16PX;
          height: 288PX;
          img {
            height: auto;
            width: 100%;
          }
        }
        .v-pic:after {
          width: 50PX;
          height: 50PX;
        }
        .v-box span {
          padding-left: 20PX;
          padding-right: 20PX;
          font-size: 18PX;
          line-height: 48PX;
          h5 {
            font-size: 18PX;
            line-height: 48PX;
          }
          font {
            font-size: 12PX;
            line-height: 48PX;
          }
        }
        .desTip {
          padding-left: 20PX;
          padding-right: 20PX;
          font-size: 14PX;
        }
        .n-box {
          width: calc(100% - 536PX);
          height: 396PX;
        }
        .n-box .n-item {
          height: 33.3%;

          img {
            margin-right: 36PX;
            width: 180PX;
          }
          .text {
            width: calc(100% - 216PX);
          }
        }
        .n-box .n-item:hover {
          box-shadow: 0 0 10PX rgba(0, 0, 0, .2);
        }
        .n-box .n-item .text .bottom {
          font-size: 14PX;
        }
        span {
          font-size: 18PX;
          line-height: 48PX;
        }
        span h5 {
          font-size: 18PX;
          line-height: 48PX;
          max-width: 80%;
        }
        span font {
          font-size: 12PX;
          line-height: 48PX;
        }
        p.des {
          font-size: 16PX;
        } // .v-box span,
        // .v-box p {
        //   padding-left: 20PX;
        //   padding-right: 20PX;
        // }
        // .v-box p {
        //   font-size: 14PX;
        // }
        // .v-box:hover {
        //   box-shadow: 0 0 10PX rgba(0, 0, 0, .2);
        // }
      }
    }
    .btnLine {
      margin-top: 30PX;
      .more-a {
        width: 150PX;
        height: 42PX;
        border-radius: 26PX;
        font-size: 16PX;
        margin-bottom: 60PX;
      }
    }
    .about-s4 {
      .s4-item {
        width: 32.6%;
        height: 130PX;
        .name {
          font-size: 18PX;
          line-height: 42PX;
        }
        .addr {
          font-size: 14PX;
        }
      }
    }
  }
  @media screen and (max-width:1199px) and (min-width:960px) {
    .imgDiv {
      padding-top: 150PX;
    }
    .about-s {
      padding-top: 50PX;
      padding-bottom: 70PX;
      h2 {
        font-size: 28PX;
      }
      h3 {
        font-size: 14PX;
        margin-bottom: 60PX;
      }
      h3:before {
        width: 115PX;
        height: 12PX;
        margin-right: 22PX;
      }
      h3:after {
        width: 115PX;
        height: 12PX;
        margin-left: 22PX;
      }
    }
    .about-s1 {
      .titleLine {
        h3 {
          margin-top: 5PX;
        }
      }
      .s1-flex {
        .itemP {
          .des {
            margin: 0PX;
            padding: 0PX;
            text-indent: 2em;
            span {
              font-size: 16PX;
            }
          }
          .tipLine {
            .tip {
              font-size: 20PX;
            }
          }
          .desItem_left {
            font-size: 18PX;
            text-align: left;
          }
        }
      }
    }
    .about-s2 {
      padding-bottom: 70PX;
      margin-top: 50PX;
      .about-s2-bg {
        padding-top: 60PX;
        padding-bottom: 80PX;
        height: 466PX;
      }
      .about-s2-bg .img-ul img {
        box-shadow: 0 9PX 10PX rgba(53, 53, 53, .4);
        width: 170PX;
        height: auto;
      }


      .tieBlock {
        height: 15.076rem;
        flex-wrap: wrap;
        .tiePicDiv {
          width: 100%;
          height: auto;
          img {
            width: 90%;
            height: auto;
          }
        }
        .tiePics {
          top: 95PX;
        }
      }
    }
    .about-s3 {
      h4 {
        font-size: 22PX;
        margin-bottom: 30PX;
      }
      h4:before {
        width: 2PX;
        height: 22PX;
        margin-right: 18PX;
      }
      .more-a {
        margin: 50PX auto 0 auto;
      }
      .s3-flex {
        .v-swiperbox {
          width: 486PX;
          height: 396PX;
          margin-right: 50PX;
          /deep/.el-carousel__arrow {
            width: 27PX !important;
            height: 44PX !important;
            .el-icon-arrow-left,
            .el-icon-arrow-right {
              font-size: 44PX;
            }
          }
        }
        .v-pic {
          margin-bottom: 16PX;
          img {
            height: 288PX;
          }
        }
        .v-pic:after {
          width: 3.6rem;
          height: 3.6rem;
        }
        .v-box span {
          padding-left: 20PX;
          padding-right: 20PX;
          font-size: 18PX;
          line-height: 48PX;
          h5 {
            font-size: 18PX;
            line-height: 48PX;
          }
          font {
            font-size: 12PX;
            line-height: 48PX;
          }
        }
        .desTip {
          padding-left: 20PX;
          padding-right: 20PX;
          font-size: 14PX;
        }
        .n-box {
          width: calc(100% - 536PX);
          height: 396PX;
        }
        .n-box .n-item {
          height: 33.3%;

          img {
            margin-right: 36PX;
            width: 180PX;
          }
          .text {
            width: calc(100% - 216PX);
          }
        }
        .n-box .n-item:hover {
          box-shadow: 0 0 10PX rgba(0, 0, 0, .2);
        }
        .n-box .n-item .text .bottom {
          font-size: 14PX;
        } // .v-pic {
        //   margin-bottom: 16PX;
        // }
        // .v-pic img {
        //   height: 288PX;
        // }
        // .v-pic:after {
        //   width: 50PX;
        //   height: 50PX;
        // }
        span {
          font-size: 18PX;
          line-height: 48PX;
        }
        span h5 {
          font-size: 18PX;
          line-height: 48PX;
          max-width: 80%;
        }
        span font {
          font-size: 12PX;
          line-height: 48PX;
        }
        p.des {
          font-size: .96rem;
        } // .v-box span,
        // .v-box p {
        //   padding-left: 20PX;
        //   padding-right: 20PX;
        // }
        // .v-box p {
        //   font-size: 14PX;
        // }
        // .v-box:hover {
        //   box-shadow: 0 0 10PX rgba(0, 0, 0, .2);
        // }
      }
    }
    .btnLine {
      margin-top: 30PX;
      .more-a {
        width: 150PX;
        height: 42PX;
        border-radius: 26PX;
        font-size: 16PX;
        margin-bottom: 60PX;
      }
    }
    .about-s4 {
      .s4-item {
        width: 32.6%;
        height: 130PX;
        .name {
          font-size: 18PX;
          line-height: 42PX;
        }
        .addr {
          font-size: 14PX;
        }
      }
    }
  }


  @media screen and (max-width:959px) and (min-width:320px) {
    .imgDiv {
      padding-top: 3.52rem;
    }
    .about-s {
      padding-top: 2rem;
      padding-bottom: 2.8rem;
      h2 {
        font-size: 1.44rem;
      }
      h3 {
        font-size: .96rem;
        margin-bottom: 2.4rem;
      }
      h3:before {
        width: 4.6rem;
        height: .048rem;
        margin-right: .88rem;
      }
      h3:after {
        width: 4.6rem;
        height: .048rem;
        margin-left: .88rem;
      }
    }
    .about-s1 {
      .titleLine {
        h3 {
          margin-top: .4rem;
        }
      }
      .s1-flex {
        .itemP {
          .des {
            margin: 0PX;
            padding: 0PX;
            text-indent: 2em;
            span {
              font-size: 1.28rem;
            }
          }
          .tipLine {
            .tip {
              font-size: 20PX;
            }
          }
          .desItem {
            font-size: 18PX;
          }
          .desItem_left {
            font-size: 18PX;
          }
        }
      }
    }
    .about-s2 {
      padding-bottom: 2.8rem;
      margin-top: 2rem;
      .about-s2-bg {
        padding-top: 2.4rem;
        padding-bottom: 3.2rem;
        height: 15.076rem;
      }
      .about-s2-bg .img-ul img {
        box-shadow: 0 9PX 10PX rgba(53, 53, 53, .4);
        width: 18.8%;
      }
      .about-s2-bg .img1,
      .about-s2-bg .img3 {
        margin-top: -4%;
      }
      .about-s2-bg .img2 {
        margin-left: 0.6rem;
      }
      .about-s2-bg .img3 {
        margin-left: 0.8rem;
      }
    }
    .about-s3 {
      h4 {
        font-size: 1.12rem;
        margin-bottom: 1.44rem;
      }
      h4:before {
        width: 2PX;
        height: 1.12rem;
        margin-right: .72rem;
      }
      .more-a {
        margin: 2rem auto 0 auto;
      }
      .s3-flex {
        -webkit-box-orient: vertical;
        -webkit-flex-direction: column;
        -moz-flex-direction: column;
        -ms-flex-direction: column;
        -o-flex-direction: column;
        flex-direction: column;
        .v-swiperbox {
          width: 100%;
          height:auto;
          // height: auto;
          margin-right: 0;
          margin-bottom:30PX;
          /deep/.el-carousel__container{
            min-height:22.393rem;
          }
          /deep/.el-carousel__arrow {
            width: 1.92rem !important;
            height: 1.92rem !important;
            .el-icon-arrow-left,
            .el-icon-arrow-right {
              font-size: 1.92rem;
            }
          }
          a.v-box {
            width: 100%;
            height: auto;
            margin-right: 0;
            margin-bottom: 1.2rem;
          }
          .v-pic {
            margin-bottom: .8rem;
            img {
              height: auto;
              width: 100%;
              max-width: none;
            }
          }
          .v-pic:after {
            width: 3.6rem;
            height: 3.6rem;
          }
          .v-box span {
            padding-left: 2.4rem;
            padding-right: 2.4rem;
            font-size: 2.08rem;
            line-height: 5.12rem;
            h5 {
              font-size: 1.04rem;
              line-height: 2.56rem;
            }
            font {
              font-size: .96rem;
              line-height: 2.56rem;
            }
          }
          .desTip {
            padding-left: 1.2rem;
            padding-right: 1.2rem;
            font-size:0.96rem;
          }
        }
        .n-box {
          width: 100%;
          height: 25.6rem;
        }
        .n-box .n-item {
          height: 33.3%;

          img {
            margin-right: 1.44rem;
            width: 7.2rem;
          }
          .text {
            width: 18.48rem;
          }
        }
        .n-box .n-item:hover {
          box-shadow: 0 0 10PX rgba(0, 0, 0, .2);
        }
        .n-box .n-item .text .bottom {
          font-size: .96rem;
        } // .v-pic {
        //   margin-bottom: 16PX;
        // }
        // .v-pic img {
        //   height: 288PX;
        // }
        // .v-pic:after {
        //   width: 50PX;
        //   height: 50PX;
        // }
        span {
          font-size: 1.04rem;
          line-height: 2.56rem;
        }
        span h5 {
          font-size: 1.04rem;
          line-height: 2.56rem;
          max-width: 80%;
        }
        span font {
          font-size: .96rem;
          line-height: 2.56rem;
        }
        p.des {
          font-size: .96rem;
        } // .v-box span,
        // .v-box p {
        //   padding-left: 20PX;
        //   padding-right: 20PX;
        // }
        // .v-box p {
        //   font-size: 14PX;
        // }
        // .v-box:hover {
        //   box-shadow: 0 0 10PX rgba(0, 0, 0, .2);
        // }
      }
    }
    .btnLine {
      margin-top: 2rem;
      .more-a {
        width: 7.04rem;
        height: 1.76rem;
        border-radius: 2.08rem;
        font-size: .96rem;
        margin-bottom: 2rem;
      }
    }
    .about-s4 {
      .s4-item {
        width: 100%;
        height: auto;
        padding: 0.8rem;
        margin-bottom: 0.96rem;
        .name {
          font-size: 1.04rem;
          line-height: 2.16rem;
        }
        .addr {
          font-size: .96rem;
        }
      }
      .s4-flex {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-flow: column;
        flex-flow: column;
      }
    }
  }

















  @media screen and (max-width:959px) and (min-width:842px) {
    .about-s {
      padding-top: 2rem;
      padding-bottom: 2.8rem;
      h2 {
        font-size: 1.44rem;
      }
      h3 {
        font-size: .96rem;
        margin-bottom: 2.4rem;
      }
      h3:before {
        width: 4.6rem;
        height: .048rem;
        margin-right: .88rem;
      }
      h3:after {
        width: 4.6rem;
        height: .048rem;
        margin-left: .88rem;
      }
    }
    .about-s1 {
      .titleLine {
        h3 {
          margin-top: .4rem;
        }
      }
      .s1-flex {
        .itemP {
          .des {
            margin: 0PX;
            padding: 0PX;
            text-indent: 2em;
            span {
              font-size: 1.28rem;
            }
          }
          .tipLine {
            .tip {
              font-size: 20PX;
            }
          }
          .desItem {
            font-size: 18PX;
          }
          .desItem_left {
            font-size: 18PX;
          }
        }
      }
    }
    .about-s2 {
      padding-bottom: 2.8rem;
      margin-top: 2rem;
      .about-s2-bg {
        padding-top: 2.4rem;
        padding-bottom: 3.2rem;
      }
      .about-s2-bg .img-ul img {
        box-shadow: 0 9PX 10PX rgba(53, 53, 53, .4);
        width: 18.8%;
      }
    }
    .about-s3 {
      h4 {
        font-size: 1.12rem;
        margin-bottom: 1.44rem;
      }
      h4:before {
        width: 2PX;
        height: 1.12rem;
        margin-right: .72rem;
      }
      .more-a {
        margin: 2rem auto 0 auto;
      }
      .s3-flex {
        .v-swiperbox {
          display: none; // width: 486PX;
          // height: 396PX;
          // margin-right: 50PX;
        }
        .n-box {
          width: 100%;
          height: 25.6rem;
        }
        .n-box .n-item {
          height: 33.3%;

          img {
            margin-right: 1.44rem;
            width: 7.2rem;
          }
          .text {
            width: 18.48rem;
          }
        }
        .n-box .n-item:hover {
          box-shadow: 0 0 10PX rgba(0, 0, 0, .2);
        }
        .n-box .n-item .text .bottom {
          font-size: .96rem;
        } // .v-pic {
        //   margin-bottom: 16PX;
        // }
        // .v-pic img {
        //   height: 288PX;
        // }
        // .v-pic:after {
        //   width: 50PX;
        //   height: 50PX;
        // }
        span {
          font-size: 1.04rem;
          line-height: 2.56rem;
        }
        span h5 {
          font-size: 1.04rem;
          line-height: 2.56rem;
          max-width: 80%;
        }
        span font {
          font-size: .96rem;
          line-height: 2.56rem;
        }
        p.des {
          font-size: .96rem;
        } // .v-box span,
        // .v-box p {
        //   padding-left: 20PX;
        //   padding-right: 20PX;
        // }
        // .v-box p {
        //   font-size: 14PX;
        // }
        // .v-box:hover {
        //   box-shadow: 0 0 10PX rgba(0, 0, 0, .2);
        // }
      }
    }
    .btnLine {
      margin-top: 2rem;
      .more-a {
        width: 7.04rem;
        height: 1.76rem;
        border-radius: 2.08rem;
        font-size: .96rem;
        margin-bottom: 2rem;
      }
    }
    .about-s4 {
      .s4-item {
        width: 100%;
        height: auto;
        padding: 0.8rem;
        margin-bottom: 0.96rem;
        .name {
          font-size: 1.04rem;
          line-height: 2.16rem;
        }
        .addr {
          font-size: .96rem;
        }
      }
      .s4-flex {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-flow: column;
        flex-flow: column;
      }
    }
  }
}
</style>